import { lazy, Suspense } from 'react';

import { useFreePassEnabled } from '@/features/free-pass';
import { useOnboardingState } from '@/features/onboarding';

const StreakSheet = lazy(() => import('@/components/StreakSheet'));
const StreakCelebration = lazy(() => import('@/components/StreakCelebration'));

const StreakSurfaces = () => {
  const enabled = useFreePassEnabled();
  const { data: onboarding } = useOnboardingState();

  if (!enabled || onboarding?.shouldShow) return null;

  return (
    <Suspense fallback={null}>
      <StreakSheet />
      <StreakCelebration />
    </Suspense>
  );
};

export default StreakSurfaces;
